module.exports = __webpack_public_path__ + "img/phone-podium.912b26cd.webp";